module.exports = __webpack_public_path__ + "static/img/inviteposter_bg.d9854ee.png";